import {
  FETCH_HOME_INSIGHTS_HEATMAP,
  FETCH_HOME_INSIGHTS_HEATMAP_ERROR,
  SET_HOME_INSIGHTS_HEATMAP,
  FETCH_HOME_INSIGHTS_SUMMARY,
  FETCH_HOME_INSIGHTS_SUMMARY_ERROR,
  SET_HOME_INSIGHTS_SUMMARY,
  FETCH_HOME_INSIGHTS_LOCATIONS,
  FETCH_HOME_INSIGHTS_LOCATIONS_ERROR,
  SET_HOME_INSIGHTS_LOCATIONS,
  FETCH_HOME_INSIGHTS_MOSTPOI,
  FETCH_HOME_INSIGHTS_MOSTPOI_ERROR,
  SET_HOME_INSIGHTS_MOSTPOI,
  FETCH_HOME_INSIGHTS_ELECTORIAL,
  FETCH_HOME_INSIGHTS_ELECTORIAL_ERROR,
  SET_HOME_INSIGHTS_ELECTORIAL,
  FETCH_HOME_INSIGHTS_SUBURBINFO,
  FETCH_HOME_INSIGHTS_SUBURBINFO_ERROR,
  SET_HOME_INSIGHTS_SUBURBINFO,
  FETCH_HOME_INSIGHTS_BRANDAFFINITY,
  FETCH_HOME_INSIGHTS_BRANDAFFINITY_ERROR,
  SET_HOME_INSIGHTS_BRANDAFFINITY,
  FETCH_HOME_INSIGHTS_WORK_LOCATIONS,
  FETCH_HOME_INSIGHTS_WORK_LOCATIONS_ERROR,
  SET_HOME_INSIGHTS_WORK_LOCATIONS,
  DOWNLOAD_HOME_INSIGHTS,
  DOWNLOAD_HOME_INSIGHTS_SUCCESS,
  DOWNLOAD_HOME_INSIGHTS_FAILURE,
} from '../constants';

// import heatMapMockData from '../../data/heatMapMockData';

const initialState = {
  summaryLoaded: false,
  summaryData: {},
  heatMapDataLoaded: false,
  heatMapData: {},
  locationsDataLoaded: false,
  locationsData: [],
  mostPoiDataLoaded: false,
  mostPoiData: [],
  electorialDataLoaded: false,
  electorialData: [],
  suburbInfoDataLoaded: false,
  suburbInfoData: {},
  brandAffinityDataLoaded: false,
  brandAffinityData: [],
  workLocationsDataLoaded: false,
  workLocationsData: [],
  downloadingCSV: false,
  csvType: null,
}

const homeInsights = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HOME_INSIGHTS_SUMMARY:
      return {
        ...state,
        summaryLoaded: false,
      };
    case FETCH_HOME_INSIGHTS_SUMMARY_ERROR:
      return {
        ...state,
      };
    case SET_HOME_INSIGHTS_SUMMARY:
      return {
        ...state,
        summaryLoaded: true,
        summaryData: action.data,
      };
    case FETCH_HOME_INSIGHTS_HEATMAP:
      return {
        ...state,
        heatMapDataLoaded: false,
      };
    case FETCH_HOME_INSIGHTS_HEATMAP_ERROR:
      return {
        ...state,
      };
    case SET_HOME_INSIGHTS_HEATMAP:
      return {
        ...state,
        heatMapDataLoaded: true,
        heatMapData: action.data,
      };
    case FETCH_HOME_INSIGHTS_LOCATIONS:
      return {
        ...state,
        locationsDataLoaded: false,
      };
    case FETCH_HOME_INSIGHTS_LOCATIONS_ERROR:
      return {
        ...state,
      };
    case SET_HOME_INSIGHTS_LOCATIONS:
      return {
        ...state,
        locationsDataLoaded: true,
        locationsData: action.data,
      };
    case FETCH_HOME_INSIGHTS_MOSTPOI:
      return {
        ...state,
        mostPoiDataLoaded: false,
      };
    case FETCH_HOME_INSIGHTS_MOSTPOI_ERROR:
      return {
        ...state,
      };
    case SET_HOME_INSIGHTS_MOSTPOI:
      return {
        ...state,
        mostPoiDataLoaded: true,
        mostPoiData: action.data,
      };
    case FETCH_HOME_INSIGHTS_ELECTORIAL:
      return {
        ...state,
        electorialDataLoaded: false,
      };
    case FETCH_HOME_INSIGHTS_ELECTORIAL_ERROR:
      return {
        ...state,
      };
    case SET_HOME_INSIGHTS_ELECTORIAL:
      return {
        ...state,
        electorialDataLoaded: true,
        electorialData: action.data,
      };
    case FETCH_HOME_INSIGHTS_SUBURBINFO:
      return {
        ...state,
        suburbInfoDataLoaded: false,
      };
    case FETCH_HOME_INSIGHTS_SUBURBINFO_ERROR:
      return {
        ...state,
      };
    case SET_HOME_INSIGHTS_SUBURBINFO:
      return {
        ...state,
        suburbInfoDataLoaded: true,
        suburbInfoData: action.data,
      };
    case FETCH_HOME_INSIGHTS_BRANDAFFINITY:
      return {
        ...state,
        brandAffinityDataLoaded: false,
      };
    case FETCH_HOME_INSIGHTS_BRANDAFFINITY_ERROR:
      return {
        ...state,
      };
    case SET_HOME_INSIGHTS_BRANDAFFINITY:
      return {
        ...state,
        brandAffinityDataLoaded: true,
        brandAffinityData: action.data,
      };
    case FETCH_HOME_INSIGHTS_WORK_LOCATIONS:
      return {
        ...state,
        workLocationsDataLoaded: false,
      };
    case FETCH_HOME_INSIGHTS_WORK_LOCATIONS_ERROR:
      return {
        ...state,
      };
    case SET_HOME_INSIGHTS_WORK_LOCATIONS:
      return {
        ...state,
        workLocationsDataLoaded: true,
        workLocationsData: action.data,
      };
    case DOWNLOAD_HOME_INSIGHTS:
      return {
        ...state,
        downloadingCSV: true,
        csvType: action.csvType,
      };
    case DOWNLOAD_HOME_INSIGHTS_SUCCESS:
      return {
        ...state,
        downloadingCSV: false,
      };
    case DOWNLOAD_HOME_INSIGHTS_FAILURE:
      return {
        ...state,
        downloadingCSV: false,
      };
    default:
      return state;
  }
}

export default homeInsights;
